import { createStyles, Theme } from '@material-ui/core';

const navigatorStyles = (theme: Theme) =>
  createStyles({
    routeHeader: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    routeHeaderPrimary: {
      color: theme.palette.common.white,
    },
    item: {
      paddingTop: 1,
      paddingBottom: 1,
      color: 'rgba(255, 255, 255)',
      '&:hover,&:focus': {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
      },
    },
    itemRoute: {
      backgroundColor: theme.palette.primary.main,
      boxShadow: `0 -1px 0 ${theme.palette.primary.main} inset`,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    title: {
      fontSize: 24,
      color: theme.palette.common.white,
    },
    itemActiveItem: {
      //color: theme.palette.primary.dark,
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
    itemPrimary: {
      fontSize: 'inherit',
    },
    itemIcon: {
      minWidth: 'auto',
      marginRight: theme.spacing(2),
    },
    divider: {
      marginTop: theme.spacing(2),
    },
  });
export default navigatorStyles;
